import normalizeOption from "./normalizeOption.mjs";
function normalizeOptions(options) {
  let {
    emptyOption
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!options && !emptyOption) {
    return [];
  }
  options = options || [];
  if (emptyOption) {
    if (typeof emptyOption !== "object") {
      emptyOption = {
        label: emptyOption
      };
    }
    emptyOption = {
      value: "",
      ...emptyOption
    };
  }
  if (!Array.isArray(options)) {
    return Object.entries(options).map(_ref => {
      let [value, rest] = _ref;
      return {
        ...normalizeOption(rest),
        value
      };
    });
  }
  options = options.map(normalizeOption);
  return emptyOption ? [emptyOption, ...options] : options;
}
export { normalizeOptions as default };